// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"bebcf5e8","498":"c4e0fe5e","545":"8ef0e2a0"}[chunkId] + ".chunk.js";
};